<div class="tiles-section section--fluent consumer-tiles-section consumer-tiles-section--no-title" [ngClass]="{ 'consumer-tiles-section--mobile': isMobile }">
    <div class="width-restrictor width-restrictor--responsive">
        <!--
            TODO: If full bleed themes are enabled for sovereign environments, make sure to set the
            full bleed theme inputs on this app-tiles-list component
        -->
        <ohp-app-tiles-list></ohp-app-tiles-list>
    </div>
</div>
